import { useQuery } from "@tanstack/react-query";
import { api } from "../utils/utils";
import { ActivePlanOfCare } from "../types";

export const patientPlansBriefQueryKey = (patientId: string) =>
  ["patient-plans-brief", patientId] as const;

export const fetchPatientPlansBrief = async (
  patientId: string,
  token: string,
): Promise<ActivePlanOfCare[]> => {
  const response = await api.get(`/plan-of-care/patient/${patientId}/brief`, token);
  return (response.data || []) as ActivePlanOfCare[];
};

type UsePatientPlansBriefParams = {
  patientId: string | undefined;
  token: string | undefined;
  enabled?: boolean;
};

export function usePatientPlansBrief({
  patientId,
  token,
  enabled = true,
}: UsePatientPlansBriefParams) {
  return useQuery({
    queryKey: patientPlansBriefQueryKey(patientId ?? ""),
    queryFn: () => fetchPatientPlansBrief(patientId!, token!),
    enabled: enabled && Boolean(patientId) && Boolean(token),
    staleTime: 0,
    refetchOnMount: "always",
    retry: 1,
  });
}
